import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const FourPointStar = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="89" viewBox="0 0 89 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.5427 0.97184L52.2697 37.5248L88.8227 45.2518L52.2697 52.9789L44.5427 89.5328L36.8156 52.9789L0.261719 45.2518L36.8156 37.5248L44.5427 0.97184Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
